import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createContainer } from '@dbk-legacy/muster/react';
import { View } from '@dbk/ui-react-utils';
import { CUSTOM_REPORT_TYPES } from '../constants';
import CustomTransactionHistory from '../report-custom-transaction-history';
import PositionsDownloads from '../reports-positions-downloads';

class ReportCustomDetails extends Component {


  render() {
    return (
      <View>
            {
                this.props.reports.custom.selectedCustomReportType === CUSTOM_REPORT_TYPES.TRANSACTION_HISTORY ?
                  <CustomTransactionHistory />:
                  <PositionsDownloads />
              }
      </View>
    );
  }
}

ReportCustomDetails.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object,
    selectedCustomReportType: PropTypes.number
  }),
};

ReportCustomDetails.defaultProps = {
  i18n: {},
};
export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    reports:{
      custom:{
        selectedCustomReportType:true,
      }
    },
    app: {
      global: {
        deviceInfo: {
          isTablet: true,
          width: true,
          height: true,
        },
      },
    },

  },
})(ReportCustomDetails);
